export const yellow = {
  backgroundColor: '#FDD32A',
  fontColor: '#06070D',
  second: '#FFFFFF30',

  card: {
    backgroundColor: '#06070D',
    fontColor: '#FFFFFF',
    shadow: '0 0.5rem 2rem -1rem #191e2790',
  },
  nav: {
    background: '#FFFFFF',
    fontColor: '#06070D',
    shadow: '0 0 3rem -1rem #191e2770',
  },
  accent: {
    blue: '#2196f3',
    red: '#f44336',
    yellow: '#ffeb3b',
    green: '#81c784',
  },
  borderRadius: 1,
};
